import type { Colors, DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  ...darkColors,
  primary: {
    lighten: '#7e92ba',
    default: '#5d76a8',
    dim: 'rgba(93,118,168,0.4)',
    mute: 'rgba(93,118,168,0.1)',
  },
  gray: {
    '100': '#ffe',
    '000': '#06070a',
    '010': '#0d0e10',
    main: '#1a1f29',
    '020': '#272c34',
    '030': '#353940',
    '040': '#43474c',
    '050': '#4a4e52',
    '060': '#53575a',
    '070': '#636668',
    '080': '#8c8f8b',
    '090': '#acaea7',
  },
  green: {
    lighten: '#41c484',
    default: '#32a06a',
    dim: 'rgba(50,160,106,0.4)',
    mute: 'rgba(50,160,106,0.1)',
  },
  red: {
    lighten: '#cf6d76',
    default: '#c24752',
    dim: 'rgba(194,71,82,0.4)',
    mute: 'rgba(194,71,82,0.1)',
  },
  yellow: {
    lighten: '#dfb550',
    default: '#d5a227',
    dim: 'rgba(213,162,39,0.4)',
    mute: 'rgba(213,162,39,0.1)',
  },
  orange: {
    lighten: '#ff8524',
    default: '#f06a00',
    dim: 'rgba(240,106,0,0.4)',
    mute: 'rgba(240,106,0,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#a778e2',
    default: '#8B4ED9',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const DarkScopeMarketsTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkSM',

  colorTextDefaultButton: '#ffffff',
  colorTextDefaultButtonHover: '#ffffff',
  colorTextDefaultButtonFocus: '#ffffff',
  colorTextDefaultButtonActive: '#ffffff',
  colorTextDefaultButtonDisabled: 'rgba(255,255,255,0.5)',

  colorTextPositiveButton: '#000000',
  colorTextPositiveButtonHover: '#000000',
  colorTextPositiveButtonFocus: '#000000',
  colorTextPositiveButtonActive: '#000000',
  colorTextPositiveButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextWarningButton: '#000000',
  colorTextWarningButtonHover: '#000000',
  colorTextWarningButtonFocus: '#000000',
  colorTextWarningButtonActive: '#000000',
  colorTextWarningButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextPrimaryButton: '#000000',
  colorTextPrimaryButtonHover: '#000000',
  colorTextPrimaryButtonFocus: '#000000',
  colorTextPrimaryButtonActive: '#000000',
  colorTextPrimaryButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextMutedButton: '#ffffff',
  colorTextMutedButtonHover: '#ffffff',
  colorTextMutedButtonFocus: '#ffffff',
  colorTextMutedButtonActive: '#ffffff',
  colorTextMutedButtonDisabled: 'rgba(255,255,255,0.5)',
});
